import { HttpClient, HttpEventType, HttpRequest } from '@angular/common/http';
import { UploadProgress, UploadProgressTracker } from 'src/app/commons/services/upload-progress.service';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppConstants } from 'src/app/commons/app-constants';

const BASE = `${AppConstants.API_URL}api/v1/tickets`;

@Injectable({ providedIn: 'root' })
export class TicketService {

  constructor(private http: HttpClient) {}

  getMyTickets(): Observable<any[]> {
    return this.http.get<any[]>(BASE, { withCredentials: true });
  }

  getTicket(id: number): Observable<any> {
    return this.http.get<any>(`${BASE}/${id}`, { withCredentials: true });
  }

  createTicket(dto: any): Observable<any> {
    return this.http.post<any>(BASE, dto, { withCredentials: true });
  }

  addReply(ticketId: number, message: string): Observable<any> {
    return this.http.post<any>(`${BASE}/${ticketId}/reply`, { message }, { withCredentials: true });
  }

  addReplyWithAttachment(ticketId: number, message: string, file?: File): Observable<any> {
    const fd = new FormData();
    if (message) fd.append('message', message);
    if (file)    fd.append('file', file);
    return this.http.post<any>(`${BASE}/${ticketId}/reply-with-attachment`, fd, { withCredentials: true });
  }

  createTicketWithAttachments(
    data: { title: string; description: string; category: string; priority: string },
    files: File[],
    onProgress: (pct: number) => void,
    /** Optional (UPLOAD_PROGRESS_PLAN.md step 3): the full live numbers — MB, speed, time left, processing. */
    onDetail?: (p: UploadProgress | null) => void,
  ): Observable<any> {
    const tracker = new UploadProgressTracker(files.reduce((n, f) => n + f.size, 0));
    const fd = new FormData();
    fd.append('title', data.title);
    fd.append('description', data.description);
    fd.append('category', data.category);
    fd.append('priority', data.priority);
    files.forEach(f => fd.append('files', f));
    const req = new HttpRequest('POST', `${BASE}/with-attachments`, fd, {
      withCredentials: true,
      reportProgress: true,
    });
    return this.http.request(req).pipe(
      map(event => {
        const up = tracker.update(event);
        if (up && onDetail) onDetail(up.state === 'done' ? null : up);
        if (event.type === HttpEventType.UploadProgress && event.total) {
          onProgress(Math.round(100 * event.loaded / event.total));
        }
        if (event.type === HttpEventType.Response) {
          return event.body;
        }
        return null;
      })
    );
  }

  rateTicket(ticketId: number, rating: number, comment?: string): Observable<any> {
    return this.http.post<any>(`${BASE}/${ticketId}/rate`, { rating, comment }, { withCredentials: true });
  }

  getOpenCount(): Observable<{ open: number }> {
    return this.http.get<{ open: number }>(`${BASE}/count`, { withCredentials: true });
  }
}
